/** @jsxImportSource @emotion/react */

'use client';

import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import * as styles from './styles';

interface Props {
  children: ReactNode;
}

export default function ActionButtonBar({ children }: Props) {
  return (
    <Stack
      direction="row"
      css={styles.actionButtonBar}
      sx={{
        alignItems: 'center',
      }}
    >
      {children}
    </Stack>
  );
}
